/** App version, injected at build time from the git release tag.
 *
 * `__APP_VERSION__` is a compile-time constant replaced by both the Vite build
 * (vite.config.ts) and the Vitest config (vitest.config.ts) via `define`. It is
 * referenced directly — esbuild's `define` skips substitution inside a `typeof`
 * guard, which would silently leave it as "dev".
 */

declare const __APP_VERSION__: string;

export const APP_VERSION: string = __APP_VERSION__;

export const REPO_URL = "https://github.com/OekoFor/flima_rebirth";

/** Link a version string to the right GitHub page:
 *  - a semver tag (e.g. "v1.3.0", or "v1.3.0-4-gabc1234" drift) → its Release page
 *  - a bare commit SHA (untagged build) → that commit
 *  - "dev" / anything else → no link
 */
export function versionHref(version: string): string | null {
  const tag = version.match(/^v?\d+\.\d+\.\d+/)?.[0];
  if (tag) return `${REPO_URL}/releases/tag/${encodeURIComponent(tag)}`;
  if (/^[0-9a-f]{7,40}$/.test(version)) return `${REPO_URL}/commit/${version}`;
  return null;
}
